
  import { Options, Vue } from 'vue-class-component';   
  import Common from '@/services/common.js';  
  import App from '../App.vue';  
  import $ from 'jquery';  
  import 'bootstrap';
  import Basic from '@/components/Basic.vue';   
  import { Form, Field,ErrorMessage } from 'vee-validate';
 
  import Axios from "axios";
  @Options({
    components: {  
      Basic,
      Form,
      Field,
      ErrorMessage
    },
    /*validations: {
      name: {
        required,
        minLength: minLength(4)
      },
      email: {
        between: between(20, 30)
      }
    }*/
  })

  export default class Login extends Vue {
    errors : string[]=[];
    err : any[]=[];
    form: any = {};
    countries =[];
    states    =[];
    cities    = []; 
    load_on:any =0;
    prev_path :any = ''; 
    STORAGE_KEY = "caprock-local";  
    session = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || "{}");
    data () {    
      Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';   
      return {  
        form: {
          user_email        : '',
          user_password     : ''
        },
        load_on:this.load_on, 
      }
    }   
    

    beforeCreate(){
      this.load_on=1;
    }

    created() {     
      // Conditional redirect based on 'onboard' query param
      // If 'onboard' exists and is non-empty, stay on this page
      // Else, redirect to external merchant login
      const onboardParam:any = (this.$route && this.$route.query && this.$route.query.onboard) ? this.$route.query.onboard : '';
      const onboardStr = typeof onboardParam !== 'undefined' && onboardParam !== null ? onboardParam.toString().trim() : '';
      if (onboardStr === '') {
        window.location.href = process.env.VUE_APP_MERCHANT_LOGIN_URL || 'https://merchant.caprock.com.au/login';
        return;
      }
    }
    
    mounted(){
      setTimeout(() => this.load_on = 0, 300);
    }
    
     
    submitForm(e:any){ 

      $('#subBtn').attr('disabled','disabled');
      $('#subBtn').text('Processing ... ');
      var js =JSON.parse(JSON.stringify((this.form))); 
      
      /*Validation Check*/
        this.errors   = []; 
        this.err   = []; 
        var required = [
          {'key':'user_email','name':'Email'},
          {'key':'user_password','name':'Password'}   
        ];
        
        var valid_emails = [ 
          {'key':'user_email','name':'Email'}  
        ];  

  
        var new_errors:any = [];
        var new_err:any = [];
        required.map(function(value, key) { 
          if (!js[value.key]) {
            var  err_msg = value.name+' is required, please fill it &#9888';
            new_errors.push(err_msg);
            new_err.push({'key':key,'value':value,'msg':err_msg});
          } 
        });  
        this.errors = new_errors;
        this.err = new_err;

        if (!this.err.length) {
          valid_emails.map(function(value, key) { 
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; 
            if (!re.test(String(js[value.key]).toLowerCase())) { 
              var  err_msg = 'Please enter a valid email address for field - '+value.name+' &#9888';
              /*new_errors.push('Please enter a valid email address for field - '+value.name);*/
              new_errors.push(err_msg);
              new_err.push({'key':key,'value':value,'msg':err_msg});
            }  
          });   
          this.errors = new_errors;
          this.err = new_err;
        }

      if (!this.err.length) {
        let form_data = new FormData(); 
        form_data.append('device_id', 'VUEDEVICE'); 
        form_data.append('device', 'VUE');   
        for (var key in js ) {
          form_data.append(key, js[key]);
        }  
        Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        var url =Common.base_url()+'web-sign-in';  
        Axios.post(url, 
          form_data, 
          {
            headers: {  
              'Content-Type': 'multipart/form-data'
            }, 
            onUploadProgress: function( progressEvent:any ) {
              var loaded:number  =  progressEvent.loaded;
              var total:number   =  progressEvent.total;
              var per   =    parseInt((loaded/total *100).toFixed()) ;  
            }.bind(this)
          }
        )
        .then(response => { 
          if(response.data.success==200){  
            if(response.data.screenCode==4){ 
              localStorage.setItem(
                this.STORAGE_KEY, JSON.stringify({
                  'access-token':response.data.user_token,
                  'user_info'   :response.data.user_info,
                  'popup'       :response.data.check_popup,
                })
              ); 
              localStorage.setItem(
                'system_access' , response.data.access
              ); 
              
              localStorage.setItem('profile_url',  response.data.user_info.profile_url); 
              localStorage.setItem('merchant_logo',  response.data.merchant_logo); 
              localStorage.setItem('merchant_version',  response.data.merchant_version); 
              
              if(response.data.access==1){
                if(typeof(this.prev_path)!=='undefined' && this.prev_path!='' && this.prev_path!=null){ 
                  this.$router.push(this.prev_path); 
                }else{ 
                  this.$router.push('/'); 
                }  
              }else{
                if(response.data.user_info['user_type']==1){
                  // this.$router.push('/individual-app');  
                  this.$router.push('/onboard');  
                }else{
                  // this.$router.push('/corporate-app');  
                  this.$router.push('/onboard');  
                } 
              }

              $('#subBtn').removeAttr('disabled');
              $('#subBtn').text('Sign In');
            }
            if(response.data.screenCode==1){ 
              return true;
            }
            if(response.data.screenCode==2){ 
              return true;
            }
            if(response.data.screenCode==3){ 
              localStorage.setItem(
                this.STORAGE_KEY, JSON.stringify({'user_email':js.user_email})
              ); 
              this.$router.push('/verify-security-code');
            }

          }else{
            // Check if the message is about pending approval
            if (response.data.message && response.data.message.includes('Your application is under review')) {
              this.openModal('pendingApprovalModal');
            } else {
              alert(response.data.message);
            }
            $('#subBtn').removeAttr('disabled');
            $('#subBtn').text('Sign In');
          } 
        })
        .catch(error => {
          $('#subBtn').removeAttr('disabled');
          $('#subBtn').text('Sign In'); 
        }); 
      }else{
        // console.log(this.err);
        /*for (var key in this.errors ) {
          form_data.append(key, js[key]);
        } */

        var errs:any =JSON.parse(JSON.stringify((this.err)));
        // console.log(errs);
        $('.errorMsg').html(''); 
        errs.map(function(v:any, k:any) { 
          var error_msg =  v.msg;  
          $("#"+v.value.key).before('<span class="'+v.value.key+'err errorMsg danger ml-2 float-right">'+error_msg+'</span>'); 
        });  
        document.body.scrollTop = 0;  
        document.documentElement.scrollTop = 0;   
        // this.openModal('exampleModal');
        e.preventDefault();  
        $('#subBtn').removeAttr('disabled');
        $('#subBtn').text('Sign In'); 
      }   
    } 

    remove_err(event:any){ 
      $('.'+event.currentTarget.id+'err').remove();
    }

    validateEmail(value) { 
        if (!value) {
            return 'Please enter email address';
        } 
        const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        if (!regex.test(value)) {
            return 'Please enter a valid email address';
        } 
        return true;
    }
    requiredField(value) { 
        if (!value) {
            return 'This field is required';
        } 
        return true;
    }
    mobileField(value){
        if (!value) {
            return 'This field is required';
        } 
        var phoneNum = value.replace(/[^\d]/g, '');
        if(phoneNum.length <7 || phoneNum.length > 12) {  
            return 'This field must be a valid mobile number';
        } 
        return true; 
    }
     

    openModal(id:any){
      $('#'+id).addClass('d-block');
      $('#'+id).addClass('show');
      $('#'+id).css('overflow-y','scroll');
    }
    closeModal(id:any){
      $('#'+id).removeClass('d-block');
      $('#'+id).addClass('d-none');
      $('#'+id).removeClass('show'); 
    }
 
      
  } 
